import {useState, useEffect} from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import Loading from '../../common/Loading';

export default function LoadListFilterShipDateOperatorList(props) {
    //console.debug("RTS Break LoadListFilterShipDateOperatorList");

    const [isLoading, setIsLoading] = useState(true);

    const [shipDateOperator, setShipDateOperator] = useState();


    useEffect(() => {
        if(props.shipDateOperator===null){
            setShipDateOperator(">=");
        }
        else{
            setShipDateOperator(props.shipDateOperator);
        }

        setIsLoading(false);
    }, [props]); 


    function valChange(e){
        props.setShipDateOperatorFx(e.target.value);
        setShipDateOperator(e.target.value);
    }    


    if(isLoading){
        return(
            <Loading />
        );
    }


    return(
        <>
            <FormControl size="small" sx={{ m: 0, minWidth: 70 }}>
                <Select
                    labelId=""
                    id="shipDateOperator"
                    value={shipDateOperator}
                    onChange={valChange}
                    label="Operator"
                >
                    <MenuItem value={">="}>&gt;=</MenuItem>
                    <MenuItem value={"<="}>&lt;=</MenuItem>
                </Select>
            </FormControl>


        </>
    );
}

